import { render } from "./GaugeFormController.vue?vue&type=template&id=42601a1e"
import script from "./GaugeFormController.vue?vue&type=script&lang=js"
export * from "./GaugeFormController.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__